import React from 'react'
import { NavLink } from 'react-router-dom'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

function Vision() {
  return (
    <div>
      <Header />

      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Vission</h2>
                <ul className="bread-list">
                  <li><NavLink to='/'>Home</NavLink></li>
                  <li><i className="icofont-simple-right" /></li>
                  <li className="active">Vission</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Breadcrumbs */}
      {/* Error Page */}
      <section className="vision-section section">
        <div className="container">
          <div className="row align-items-center">
            {/* Left side content */}
            <div className="col-lg-6 col-12">
              <div className="vision-content">
                <h4 style={{ color: '#007bff', marginBottom: '20px' }}>Our Vision </h4>
                <ul className="list-unstyled" style={{ fontSize: '1.1rem', color: '#444', paddingLeft: '20px' }}>
                  <li style={{ marginBottom: '15px', paddingLeft: '10px' }}>
                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                    Provide high-quality, affordable healthcare for everyone
                  </li>
                  <li style={{ marginBottom: '15px', paddingLeft: '10px' }}>
                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                    Embrace innovation and technology to improve patient outcomes
                  </li>
                  <li style={{ marginBottom: '15px', paddingLeft: '10px' }}>
                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                    Build a healthier future through community outreach and education
                  </li>
                  <li style={{ marginBottom: '15px', paddingLeft: '10px' }}>
                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                    Foster a compassionate and respectful environment for all
                  </li>
                </ul>
                <p style={{ marginTop: '20px', fontSize: '1rem', color: '#666' }}>
                  Our commitment is driven by a deep sense of responsibility to care for every patient with dignity,
                  empathy, and excellence.
                </p>
              </div>
            </div>

            {/* Right side image */}
            <div className="col-lg-6 col-12">
              <div className="vision-image">
                <img src="img/blog3.jpg" alt="Vision" style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*/ End Error Page */}
      <Footer />
    </div>
  )
}

export default Vision